<template>
  <div class="progress">
    <div class="progress-back">
      <div class="progress-line yellow" :class="$attrs.progressClass"
           :style="{width:progress<=10?'60px':progress+'%',...progressStyle}"
           v-if="progress>0">
        {{ progress }}%
      </div>
      <div class="progress2" :style="{width:progress<=10?'60px':progress+'%',...progressStyle}">{{ progress }}%</div>
    </div>
    <div class="arrow"></div>
  </div>
</template>

<script>
export default {
  name: "mLineProgress",
  inheritAttrs: false,
  props: {
    progress: {
      type: [String, Number],
      default: '0'
    },
    progressStyle: {
      type: Object,
      default: () => ({})
    }
  },

}
</script>

<style scoped lang="scss">
.progress {
  width: 90%;
  height: calc(0.69 * var(--fontSize));
  border-radius: calc(0.16 * var(--fontSize));
  background: linear-gradient(180deg, #F3F5F7 0%, #F3F5F7 9.91%, #FEFEFF 100%);
  border: 1px solid #FFFFFF;
  box-shadow: -4px -4px 10px 0px #FFFFFF, 4px 4px 10px 0px #DEDDE3;
  margin-top: calc(0.6 * var(--fontSize));
  display: flex;
  justify-content: space-around;
  align-items: center;

  & > .arrow {
    height: calc(0.12 * var(--fontSize));
    width: calc(0.12 * var(--fontSize));
    border-top: 3px solid #000000;
    border-right: 3px solid #000000;
    border-radius: 3px;
    transform: rotate(45deg);
    //cursor: pointer;
  }

  & > .progress-back {
    width: 80%;
    height: calc(0.3 * var(--fontSize));
    opacity: 1;
    border-radius: calc(0.74 * var(--fontSize));
    background: linear-gradient(180deg, #DDE4EB 0%, #E9EDF2 9.91%, #FAFAFA 100%);
    box-shadow: 4px 4px 10px 0px #FFFFFF;
    overflow: hidden;
    position: relative;

    & > .progress2 {
      height: 100%;
      position: absolute;
      z-index: 2;
      inset: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      pointer-events: none;
      opacity: 0;
      color: white;
      transition: .5s;
      font-weight: bold;
    }

    & > .progress-line {
      height: 100%;
      border-radius: 100px;
      border: 1px solid #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: calc(0.14 * var(--fontSize));
      color: white;
      transition: .5s;
    }

    & > .progress-line:hover {
      filter: contrast(130%) blur(5px);
      & + .progress2 {
        opacity: 1;
      }
    }

    & > .yellow {
      background: linear-gradient(90deg, rgba(255, 213, 77, 1) 0%, rgba(255, 170, 0, 1) 100%);
    }

    & > .orange {
      background: linear-gradient(270deg, rgba(255, 121, 61, 1) 0%, rgba(255, 182, 122, 1) 100%);
    }

    & > .red {
      background: linear-gradient(90deg, rgba(255, 181, 181, 1) 0%, rgba(252, 130, 96, 1) 100%);
    }

    & > .purple {
      background: linear-gradient(90deg, rgba(201, 201, 255, 1) 0%, rgba(153, 153, 255, 1) 100%);
    }

    & > .blue {
      background: linear-gradient(90deg, #5FD3FF 0%, #30A9FF 100%);
    }

    & > .green {
      background: linear-gradient(90deg, rgba(122, 240, 169, 1) 0%, rgba(23, 191, 90, 1) 100%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mLineProgress.vue